
/*
Author: Vinod
Date: 07/04/2020
Issue Description: Form 16 annexure : UI issues
search_string: PL_1133
*/

<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="filters">
      <tl-select label="Month" labelText="name" name="month" :options="monthList"></tl-select>
      <tl-select label="Paygroups" labelText="name" name="paygroups" :options="payGroupList"></tl-select>
      <tl-select
        label="Employee Status"
        labelText="name"
        name="employeestatus"
        :options="employeeStatusList"
      ></tl-select>
      <tl-select
        label="Criteria"
        labelText="name"
        name="criteria"
        :options="criteriaList"
        @change="onSelectCriteria($event)"
      ></tl-select>
      <tl-select
        v-show="this.filterForm.criteria"
        label="Sub-Criteria"
        name="subcriteria"
        :options="subCriteriaList"
      ></tl-select>
      <btn text="Apply Filter" type="secondary" class="filter-btn margintop-20" />
    </div>
    <div class="threeColumnGrid">
      <search-dropdown
        :employeeData="employeeData"
        class="margintop-20"
        @empselected="(emp)=>selectedEmp(emp)"
      />
    </div>
    <data-table
      :columns="tableColumns"
      :tableData="employeeData"
      :checkbox="true"
      :showinrow="false"
      @selected="selected"
      @deselected="deselected"
      class="margintop-30"
    >
      <template v-slot:rowcontent="slotprops">
        <img
          class="sm-img"
          v-if="slotprops.value.column.key=='imgSrc'"
          :src="slotprops.value.record[slotprops.value.column.key]"
        />
        <p
          v-if="slotprops.value.column.key!='imgSrc' && slotprops.value.column.key !='attachments'"
        >{{slotprops.value.record[slotprops.value.column.key]}}</p>
      </template>
    </data-table>
    <div class="modal custom-modal" v-if="showModal">
      <div class="modal-content modal-sm">
        <div class="modal-header">
          <h3>Export As</h3>
        </div>
        <div class="modal-body">
          <div class="singleColumnGrid p-10">
            <!-- PL_1133 -->
            <div class>Downloading as {{fileType}}</div>
            <tl-radio
              label="Single File"
              name="reports"
              id="single_file"
              value="singleFile"
              v-model="no_of_files"
            />
            <tl-radio
              label="Multiple Files"
              name="reports"
              id="multiple_files"
              value="multipleFiles"
              v-model="no_of_files"
            />
          </div>
          <btn-grp slot="end">
            <btn text="Cancel" type="secondary" class v-on:click="backToDownloadPage"></btn>
            <btn text="Download" type="primary" class v-on:click="downLoadFiles"></btn>
          </btn-grp>
        </div>
      </div>
    </div>
    <!-- Start PL_1133 -->
    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" />
          <btn text="Download" type="primary" @click="download" />
          <div class="file-download-dropdown" v-show="showDropdown">
            <ul>
              <li>
                <a href="javascript:void(0)" v-on:click="downloadFile('PDF')">PDF</a>
              </li>
              <li>
                <a href="javascript:void(0)" v-on:click="downloadFile('Excel')">Excel</a>
              </li>
            </ul>
          </div>
        </btn-grp>
      </template>
    </bottom-action-container>
    <!-- End PL_1133 -->
  </div>
</template>
<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
export default {
  name: "DownloadFormAnnexure",
  components: {
    SearchDropdown
  },
  data() {
    return {
      showModal: false,
      showDropdown: false,
      no_of_files: "singleFile", // PL_1133
      errmsg:'', // PL_1133
      toast:false, // PL_1133
      fileType: "", // PL_1133
      filterForm: {
        month: [],
        paygroupId: "",
        employeeStatus: "",
        criteria: "",
        subCriteria: ""
      },
      tableColumns: [
        {
          label: "",
          key: "imgSrc"
        },
        {
          label: "Code",
          key: "code"
        },
        {
          label: "Name",
          key: "name"
        },
        {
          label: "Department",
          key: "department"
        },
        {
          label: "Email ID",
          key: "email"
        },
        {
          label: "Location",
          key: "location"
        }
      ],
      monthList: [
        {
          name: "January",
          value: "jan"
        },
        {
          name: "February",
          value: "feb"
        },
        {
          name: "March",
          value: "mar"
        },
        {
          name: "April",
          value: "apr"
        },
        {
          name: "May",
          value: "may"
        },
        {
          name: "June",
          value: "june"
        }
      ],
      payGroupList: [
        {
          name: "Paygroup 1",
          value: "paygroup1"
        },
        {
          name: "Paygroup 2",
          value: "paygroup2"
        },
        {
          name: "Paygroup 3",
          value: "paygroup3"
        }
      ],
      employeeStatusList: [
        {
          name: "Active",
          value: "active"
        },
        {
          name: "Inactive",
          value: "inactive"
        }
      ],
      criteriaList: [
        {
          name: "Location",
          value: "location"
        },
        {
          name: "Designation",
          value: "designation"
        }
      ],
      subCriteriaList: ["Lucknow", "Hyderabad", "Mumbai", "Chennai"],
      employeeData: [
        {
          id: 1,
          code: "RC1234",
          name: "Roxi",
          department: "IT",
          email: "Roxi@gmail.com",
          location: "Hyderabad",
          imgSrc: require("@/assets/user.svg")
        }
      ]
    };
  },
  methods: {
    onSelectCriteria(event) {
      this.filterForm.criteria = event.value;
    },
    selectedEmp(emp) {},
    selected(records) {},
    deselected(records) {},
    download() {
      this.showDropdown = !this.showDropdown;
    },
    backToDownloadPage() {
      this.showModal = false;
    },
    downLoadFiles() {},
    // PL_1133
    downloadFile(type) {
      try {
        this.fileType = type;
        this.showDropdown = false;
        this.showModal = true;
      } catch (error) {
        this.errmsg = error;
        this.toast = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.filters {
  display: grid;
  grid-gap: 10px;
  grid-template: auto / repeat(6, minmax(180px, 1fr));
}
.filter-btn {
  height: 34px;
  min-height: 34px;
  width: 110px;
  padding: 0px;
}
.btn-center {
  position: relative;
  top: 70px;
  margin: auto;
}
.footer-btn {
  border-top: 1px solid #34c0be;
  margin-top: 20px;
  padding: 15px;
  bottom: 0px;
  position: fixed;
  width: 66%;
  text-align: right;

  .btn-cancel {
    border: 1px solid #34c0be;
    border-radius: 4px;
    color: #34c0be;
    font-weight: 600;
    min-width: 205px;
    min-height: 45px;
    padding: 14px;
    margin: 10px;
  }
  .btn-submit {
    background-color: #5d409f;
    border: 1px solid #5d409f;
    border-radius: 4px;
    font-weight: 600;
    color: #fff;
    min-width: 205px;
    min-height: 45px;
    padding: 14px;
    margin: 10px;
  }
}
.file-download-dropdown {
  li {
    padding: 5px;
    width: 100%;
    a {
      width: 100%;
      text-decoration: none;
      color: #2c3e50;
    }
  }
  display: black;
  position: absolute;
  z-index: 1;
  right: 80px;
  bottom: 85px;
  width: 100px;
  height: 80px;
  text-align: left;
  padding: 10px;
  background-color: #fff;
  -webkit-box-shadow: 0 4px 4px 4px rgba(186, 186, 186, 0.5);
  box-shadow: 0px 0px 4px 4px rgba(152, 152, 152, 0.14);
}
.file-download-dropdown::after {
  content: "";
  position: absolute;
  top: 80px;
  left: 20px;
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 11px solid white;
}
</style>
